import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../_App/Redux/hooks";
import {
  SelectedOrganisation,
  SelectedOrganisations,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import Filtre from "./Filtre";
import PaginationLayout from "../../_Layouts/Pagination/PaginationLayout";
import { Form, Spinner } from "react-bootstrap";

import {
  allOrganisationsApi,
  ListOrganisations,
} from "../../_App/Redux/Slices/organisations/organisationSlice";
import { findDepotsBySocieteApi } from "../../_App/Redux/Slices/depot/depotSlice";
import Select from "react-select";
import {
  findRapportAchatVenteApi,
  ValstockfilterApi,
  ValstockfilterApiExcel,
} from "../../_App/Redux/Slices/rapport/rapportSlice";

export default function ValStockTableArticle({
  t,
  setindex,
  index,
  handleSearch,
  setkeyword,
  keyword,
  spinner,
  setspinner,
  setdatafilter,
  dispatch,
  societe,
  totalPrix,
  totalQte,
  listDepots,
  stock,
  listarticle,
}: any) {
  const [selectedCarte, setSelectedCarte] = useState<any[]>([]);
  const [selectedCategorie, setSelectedCategorie] = useState<any[]>([]);
  const [selectedSousCategorie, setSelectedSousCategorie] = useState<any[]>([]);
  const [intervaleRef, setintervaleRef] = useState<any>();
  const [intervalePrix, setintervalePrix] = useState<any>();
  const listOrganisations = useAppSelector(ListOrganisations);
  const [selectedOrganisationsId, setSelectedOrganisationsId] = useState<any[]>(
    [],
  );
  const [selectedMarques, setSelectedMarques] = useState([]);
  const [selectedDepotId, setSelectedDepotId] = useState<any[]>([]);
  const [depotsOption, setDepotsOption] = useState<any[]>([]);
  const currentOrganisation = useAppSelector(SelectedOrganisation);
  const [categoriesOptions, setcategoriesdOptions] = useState<any[]>([]);
  const [souscategoriesOptions, setsouscategoriesdOptions] = useState<any[]>(
    [],
  );
  interface SelectionsState {
    [key: string]: any[];
  }
  const [selections, setSelections] = useState<SelectionsState>({});
  const optionOrganisation = listOrganisations?.map((option) => ({
    value: option._id,
    label: option.nom,
  }));
  useEffect(() => {
    if (currentOrganisation) {
      const fetchData = async () => {
        const optionDepots = listDepots[currentOrganisation._id]?.map(
          (option: any) => ({
            value: option._id,
            label: option.libelle,
          }),
        );
        const depotsdefaut = listDepots[currentOrganisation._id]?.filter(
          (d: any) => d.defaut,
        );
        setSelectedDepotId(depotsdefaut?.map((d: any) => d._id));
        setDepotsOption(optionDepots);
        setSelectedOrganisationsId([currentOrganisation._id]);
        setspinner(true);

        const data = {
          listOrganisation: [currentOrganisation._id],
          listDepots: depotsdefaut?.map((d: any) => d._id),
        };
        setindex(1);
        setdatafilter(data);

        await dispatch(ValstockfilterApi(data));
        // dispatch(findRapportAchatVenteApi(data))
      };

      fetchData();
    }
  }, [currentOrganisation]);

  const searchfiltre = async () => {
    setspinner(true);
    const carateristiqueOptions: any[] = [];

    for (const key in selections) {
      if (Array.isArray(selections[key])) {
        selections[key].forEach((obj) => {
          carateristiqueOptions.push(obj.value);
        });
      }
    }
    const data = {
      carte: selectedCarte,
      categories: selectedCategorie,
      sousCategories: selectedSousCategorie,
      carateristique: carateristiqueOptions,
      motcle: keyword,
      index: index,
      ref1: intervaleRef?.ref1,
      ref2: intervaleRef?.ref2,
      prix1: intervalePrix?.prix1,
      prix2: intervalePrix?.prix2,
      listOrganisation: selectedOrganisationsId,
      listDepots: selectedDepotId,
      listMarque: selectedMarques.map((m: any) => m.value),
    };

    setdatafilter(data);
    await dispatch(ValstockfilterApi(data));
  };
  const callApi = async () => {
    setspinner(true);
    const carateristiqueOptions: any[] = [];

    for (const key in selections) {
      if (Array.isArray(selections[key])) {
        selections[key].forEach((obj) => {
          carateristiqueOptions.push(obj.value);
        });
      }
    }
    const data = {
      carte: selectedCarte,
      categories: selectedCategorie,
      sousCategories: selectedSousCategorie,
      carateristique: carateristiqueOptions,
      motcle: keyword,
      index: index,
      ref1: intervaleRef?.ref1,
      ref2: intervaleRef?.ref2,
      prix1: intervalePrix?.prix1,
      prix2: intervalePrix?.prix2,
      listOrganisation: selectedOrganisationsId,
      listDepots: selectedDepotId,
      listMarque: selectedMarques.map((m: any) => m.value),
    };

    setdatafilter(data);
    await dispatch(ValstockfilterApi(data));
    //  await dispatch(findRapportAchatVenteApi(data))
  };
  useEffect(() => {
    callApi();
  }, [index]);
  const handleChange = (selectedOption: any) => {
    const listdepotsOrgs = [];
    const depotdefaut = [];
    const org = selectedOption.map((item: any) => item.value);
    setSelectedOrganisationsId(org);
    if (selectedOption.length === 0) {
      const depots = listDepots["null"];
      const optionDepots = depots?.map((option: any) => ({
        value: option._id,
        label: option.libelle,
      }));
      listdepotsOrgs.push(optionDepots);

      const defaultDepot = depots.find((d: any) => d.defaut);
      if (defaultDepot) {
        depotdefaut.push(defaultDepot._id);
      }
    } else {
      for (let i = 0; i < org.length; i++) {
        const orgId = org[i];
        const depots = listDepots[orgId];
        const optionDepots = depots?.map((option: any) => ({
          value: option._id,
          label: option.libelle,
        }));
        listdepotsOrgs.push(optionDepots);

        const defaultDepot = depots.find((d: any) => d.defaut);
        if (defaultDepot) {
          depotdefaut.push(defaultDepot._id);
        }
      }
    }
    setSelectedDepotId(depotdefaut);
    setDepotsOption(listdepotsOrgs?.flat());
  };
  const handleChangeDepot = (selectedOption: any) => {
    const dep = selectedOption.map((item: any) => item.value);
    setSelectedDepotId(dep);
  };
  const exportExcel =async()=>{
    setspinner(true);
    const carateristiqueOptions: any[] = [];

    for (const key in selections) {
      if (Array.isArray(selections[key])) {
        selections[key].forEach((obj) => {
          carateristiqueOptions.push(obj.value);
        });
      }
    }
    const data = {
      carte: selectedCarte,
      categories: selectedCategorie,
      sousCategories: selectedSousCategorie,
      carateristique: carateristiqueOptions,
      motcle: keyword,
      index: index,
      ref1: intervaleRef?.ref1,
      ref2: intervaleRef?.ref2,
      prix1: intervalePrix?.prix1,
      prix2: intervalePrix?.prix2,
      listOrganisation: selectedOrganisationsId,
      listDepots: selectedDepotId,
      listMarque: selectedMarques.map((m: any) => m.value),
    };

    setdatafilter(data);
    await dispatch(ValstockfilterApiExcel(data));
    //  await dispatch(findRapportAchatVenteApi(data))
      setspinner(false);

  }
  return (
    <div>
      <div className="row layout-spacing">
        <div className="row layout-spacing">
          <div className="col-lg-12   bg-white  ">
            <div className="row mt-2">
              <div className="col-1">
                <label>{t("Magasins")}</label>
              </div>
              <div className="col-4">
                <Select
                  isMulti
                  options={optionOrganisation}
                  isSearchable={true}
                  onChange={handleChange}
                  value={selectedOrganisationsId?.map((item: any) =>
                    optionOrganisation?.find((cat: any) => cat.value === item),
                  )}
                />
              </div>
              <div className="col-1">
                <label>{t("Depots")}</label>
              </div>
              <div className="col-4">
                <Select
                  isMulti
                  options={depotsOption}
                  isSearchable={true}
                  onChange={handleChangeDepot}
                  value={selectedDepotId?.map((item: any) =>
                    depotsOption?.find((cat: any) => cat.value === item),
                  )}
                />
              </div>
            </div>
            <Filtre
              spinner={spinner}
              handleSearch={handleSearch}
              setkeyword={setkeyword}
              t={t}
              selectedMarques={selectedMarques}
              setSelectedMarques={setSelectedMarques}
              setspinner={setspinner}
              setdatafilter={setdatafilter}
              setindex={setindex}
              searchfiltre={searchfiltre}
              selectedCarte={selectedCarte}
              setSelectedCarte={setSelectedCarte}
              selectedCategorie={selectedCategorie}
              setSelectedCategorie={setSelectedCategorie}
              selectedSousCategorie={selectedSousCategorie}
              setSelectedSousCategorie={setSelectedSousCategorie}
              categoriesOptions={categoriesOptions}
              setcategoriesdOptions={setcategoriesdOptions}
              souscategoriesOptions={souscategoriesOptions}
              setsouscategoriesdOptions={setsouscategoriesdOptions}
              selections={selections}
              setintervaleRef={setintervaleRef}
              intervaleRef={intervaleRef}
              setintervalePrix={setintervalePrix}
              intervalePrix={intervalePrix}
              setSelections={setSelections}
            />
          </div>
        </div>
      </div>

      <div className="row bg-white ">
        <div className=" col-5     " style={{ padding: "20px" }}>
          <div>
            <strong style={{ fontWeight: "bold " }}>
              {t("Total Stock")} : {totalQte}{" "}
            </strong>
          </div>
        </div>
        <div className=" col-5  " style={{ padding: "20px" }}>
          <div>
            <strong style={{ fontWeight: "bold " }}>
              {t("Total Prix Vente TTC")} : {totalPrix}{" "}
            </strong>
          </div>
        </div>
      </div>
      <div className="row bg-white mt-3 ">
        <button className="btn  btn-primary" onClick={exportExcel}> export ecel</button>
        <table className="table">
          <thead>
            <th>{t("Code a barre")}</th>
            <th>{t("Article")}</th>
            <th>{t("Prix")}</th>
            <th>{t("Stock")}</th>
            <th>{t("Prix Total")}</th>
          </thead>
          <tbody>
            {stock.map((s: any, i: number) => (
              <tr>
                <td
                  style={{
                    fontSize: "17px",
                  }}
                >
                  {s.code_a_barre[0]}
                </td>
                <td
                  style={{
                    fontSize: "17px",
                  }}
                >
                  {s.code_article}
                </td>
                <td
                  style={{
                    fontSize: "17px",
                  }}
                >
                  {s.prix_vente_ttc}
                </td>
                <td
                  style={{
                    fontSize: "17px",
                  }}
                >
                  {s.stock_actuel}
                </td>
                 <td
                  style={{
                    fontSize: "17px",
                  }}
                >
                  {(s.stock_actuel*s.prix_vente_ttc).toFixed(3)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
/*   <td key={key}> {/* Ensure each cell has a unique key */
//{stock.find((st: any) => (
//  st.depots_id._id === key && // Check if depots_id matches the current key
//st.article_id !== null && // Ensure article_id is not null
// st.article_id._id === item.article_id._id// Check if article_id matches the specific ID
//))?.stock || key}
//</td>*/
/*          {lists.map((item , indexl)=> (
    <tr key={indexl}> 
    <td>{item.article._id}</td>
    {list_depots.map((element:any , index:number) => (
        <td key={index}>{item[element]}</td>
    ))}
</tr>
))}*/
